// @flow strict
import React from 'react';
import appendScriptOnce from '../../internal/util/appendScriptOnce';

type Props = {
  channelId: string,
};

const WistiaChannel = (props: Props) => {
  React.useEffect(() => {
    appendScriptOnce({
      src: 'https://fast.wistia.com/assets/external/channel.js',
      id: 'wistiaChannelScript',
    });
  }, [props.channelId]);

  return (
    <div
      className={`wistia_channel wistia_async_${
        props.channelId
      } mode=inline videoFoam=true wmode=true`}
      style={{ minHeight: '100vh', position: 'relative' }}
    >
      &nbsp;
    </div>
  );
};

export default WistiaChannel;
